import { call, put, takeLatest, cancelled } from "redux-saga/effects"

import axios from "axios"

import {
  CLEAR_TABLE_WATCHER,
  GET_MEDITIONS_ORGANIZATION_WATCHER,
  SUBMIT_FEEDBACK_SURVEY_WATCHER,
  DISMISS_FEEDBACK_SURVEY_WATCHER,
  GET_VISMA_PEOPLE_STATUS_WATCHER,
} from "./constants"

import { clearTableSuccess, getMeditionsSuccess, getVismaPeopleStatusFailed, getVismaPeopleStatusSuccess } from "./actions"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../utils/storage"

function getMeditionsApi(params) {
  // all-data=0: esta pantalla solo usa name/id_measure; evita calcular demografía y embajadores
  const url = `companies/${LOCAL_COMPANY_ID()}/measure?all-data=0`
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

function clearTableApi() {
  return axios.request({
    method: "delete",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL
      }companies/${LOCAL_COMPANY_ID()}/divisions/clear`,
  })
}

export function* clearTemplateSaga() {
  try {
    yield call(clearTableApi)
    yield put(clearTableSuccess())
    location.reload()
  } catch (e) { }
}

export function* getMeditionsSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const meditionsApi = yield call(getMeditionsApi, params.payload)
    const result = {}
    result.meditions = meditionsApi.data.data.measure
    yield put(getMeditionsSuccess(result.meditions))
  } catch (e) { }
}

function submitFeedbackSurveyApi(params) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}feedback-survey/`,
    data: {
      id_company: Number(LOCAL_COMPANY_ID()),
      score: params.score,
      comments: params.comments
    }
  })
}
function dismissFeedbackSurveyApi(){
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}feedback-survey/dismiss`,
  })
}

export function* submitFeedbackSurveySaga(params) {
  try {
    yield call(submitFeedbackSurveyApi, params.payload)
  } catch (e) { }
}
export function* dismissFeedbackSurveySaga(params) {
  try {
    yield call(dismissFeedbackSurveyApi)
  } catch (e) { }
}

export function getVismaPeopleStatusApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/synchronizations/status`,
  })
}

export function* getVismaPeopleStatusSaga(action) {
  try {
    const { data, status } = yield call(getVismaPeopleStatusApi)

    if (status === 200) {
      yield put(getVismaPeopleStatusSuccess(data.data))
    }
  } catch (e) {
    console.log(e)
    yield put(getVismaPeopleStatusFailed())
  }
}


export default function* getDivisionsWatcherSaga() {
  yield takeLatest(CLEAR_TABLE_WATCHER, clearTemplateSaga)
  yield takeLatest(GET_MEDITIONS_ORGANIZATION_WATCHER, getMeditionsSaga)
  yield takeLatest(SUBMIT_FEEDBACK_SURVEY_WATCHER, submitFeedbackSurveySaga)
  yield takeLatest(DISMISS_FEEDBACK_SURVEY_WATCHER, dismissFeedbackSurveySaga)
  yield takeLatest(GET_VISMA_PEOPLE_STATUS_WATCHER, getVismaPeopleStatusSaga)
}
